import io from 'socket.io-client';
import Vue from 'vue';


import storage from 'src/util/storage';
import * as actions from 'src/store/socket/actions';

let socket = null;

const createSocket = (token, store) => {
	try {
		if (socket) socket.close();

		if (!token) return;

		const { origin: server } = new URL(process.env.VUE_APP_API_URL);
		socket = io(server, {
			query: {
				authorization: `JWT ${token}`,
			},
		});

		socket.on('message', ({ event, payload }) => {
			const action = event.replace(/([-_]\w)/g, m => m[1].toUpperCase());
			if (action in actions) {
				store.dispatch(`socket/${action}`, payload);
			} else if (process.env.DEV) {
				// eslint-disable-next-line no-console
				console.warn(`Unhandeled socket message, maybe implement ${action}(`, payload, ') as action in the socket store!');
			}
		});

		Vue.prototype.$socket = socket;

	} catch (error) {
		console.error(error);
		socket = null;
	}
};

// Send errors to backend via socket
const consoleError = console.error;
console.error = (...args) => {
	handleError(...args);
	consoleError(...args);
};

window.addEventListener('error', (event) => {
	handleError(event.error);
});

function handleError(...args) {
	args = args.map((arg) => {
		if (arg instanceof Error) {
			if (arg.name === 'ChunkLoadError') {
				setTimeout(() => {
					window.location.reload();
				}, 0);
			}
			return {
				message: arg.message,
				stack: arg.stack,
				...arg,
			};
		}
		return arg;
	});

	if (socket) {
		socket.send('FRONTEND_ERROR', args);
	}
}

export default async ({ store }) => {
	const accessToken = storage.get('auth.accessToken');
	createSocket(accessToken, store);

	store.subscribe(({ type, payload }) => {
		if (type !== 'auth/SET_ACCESS_TOKEN') return;
		createSocket(payload, store);
	});
};
